<template>
  <div
    :class="userIdentity"
    class="nav-card-login-info"
  >
    <div
      class="nav-info"
    >
      <div class="nav-info-top">
        <Title
          v-report="{
            id: 'button',
            params: {
              type: 'nickname',
              ...publicReport,
            },
          }"
          class="user-nick"
          :title="loginInfo.userNick"
          :number-of-lines="1"
          :style="userNickStyle"
          @click.stop="toPersonalPage"
        />

        <div class="nav-type">
          <LoginTypeIcon :login-type="loginInfo.type" />
        </div>
        <div
          v-for="(icon, index) in iconList"
          :key="index"
          class="user-icon-list"
        >
          <img
            v-if="!!icon.pic"
            class="user-icon"
            :src="icon.pic"
            alt=""
          >
        </div>
      </div>
      <div class="nav-info-bottom">
        <div
          v-report="{
            id: 'button',
            params: {
              type: 'points',
              ...publicReport,
            },
          }"
          class="integral"
          :style="{
            color: cardStyle.nickColor,
          }"
          @click.stop="openIntegral"
        >
          <span :title="integralInfo.subTitle || 0"> 积分 {{ integralInfo.subTitle || 0 }}</span>
        </div>
        <div
          v-report="{
            id: 'button',
            params: {
              type: 'diamonds',
              ...publicReport,
            },
          }"
          class="diamonds"
          :style="{
            color: cardStyle.nickColor,
          }"
          @click.stop="openDiamonds"
        >
          <span :title="isFamilySub ? 0 : (diamondsInfo.subTitle || 0)"> 钻石 {{ isFamilySub ? 0 : (diamondsInfo.subTitle || 0) }}</span>
        </div>
        <div
          v-report="{
            id: 'button',
            params: {
              type: 'vip_message',
              ...publicReport,
            },
          }"
          class="message"
          :style="{
            color: cardStyle.nickColor,
          }"
          @click.stop="openVipMessage"
        >
          <span> VIP消息 </span>
          <div
            v-if="hasNewMsg"
            class="message-tip"
          />
        </div>
      </div>
    </div>
    <!-- 大图标 -->
    <div
      v-if="iconInfo.vipBigIcon && isLogin"
      style="flex-shrink: 0; flex-direction: row; align-items: center; margin-left: 12px"
    >
      <!-- V8 -->
      <ImageView
        :src="iconInfo.vipBigIcon"
        class="level"
        :watch-key="userIdentity"
        :style="{
          'tint-color': cardStyle.nickColor,
          '--tint-color': cardStyle.nickColor,
        }"
      />
    </div>
  </div>
  <div
    v-if="isFamilySub"
    class="family-sub"
  >
    <span
      :style="{
        color: cardStyle.nickColor,
      }"
    >{{ vipCard.title }}{{ vipCard.subTitle }}到期</span>
    <div
      class="tip-img-box"
      @mouseenter="onMouseEnter"
      @mouseleave="onMouseLeave"
    >
      <ImageView
        v-if="!isTipHover"
        :src="TipImg"
        class="tip-img"
      />
      <ImageView
        v-else
        :src="TipHover"
        class="tip-img"
      />
      <div
        v-if="isTipHover"
        :class="{
          'tip-text-web': !isEvo,
          'tip-text-evo': isEvo,
        }"
      >
        <div class="tip-text-title">
          <span> 家庭卡开通及续费、附属身份停用及删除功能，需在腾讯视频APP端V8.11.25及以上版本操作。 </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, defineProps, computed, watch } from 'vue';
import ImageView from '@/components/image-view.vue';
import LoginTypeIcon from './login-type-icon.vue';
import { isMac } from '@/common/utils';
import { onLoginReady } from '@/composables/useOnLoginReady';
import Title from '@/components/title.vue';
import { useLoginStore } from '@/store/login-store';
import TipImg from '@/assets/img/tip.png';
import TipHover from '@/assets/img/tip-hover.png';
import { storeToRefs } from 'pinia';

const props = defineProps({
  loginInfo: {
    type: Object,
    default: () => {
      { }
    },
  },
  iconInfo: {
    type: Object,
    default: () => {
      { }
    },
  },
  iconList: {
    type: Array,
    default: () => [],
  },
  integralInfo: {
    type: Object,
    default: () => {
      { }
    },
  },
  diamondsInfo: {
    type: Object,
    default: () => {
      { }
    },
  },
  userIdentity: {
    type: String,
    default: 'noVip',
  },
  vipCard: {
    type: Object,
    default: () => {
      {}
    },
  },
  cardStyle: {
    type: Object,
    default: () => {
      { }
    },
  },
});
const enableFVipSwitch = ref(false);
const loginStore = useLoginStore();
const { publicReport } = storeToRefs(loginStore);
const isEvo = import.meta.env.EVO;
const isLogin = computed(() => loginStore.isLogin);
const isFamilySub = computed(() => loginStore.isFamilySub);
const isTipHover = ref(false);
const hasNewMsg = ref(false);

watch(
  () => loginStore.hasNewMsg,
  (newVal) => {
    hasNewMsg.value = newVal;
  },
  { immediate: true },
);

const userNickStyle = computed(() => {
  const { nickColor } = props.cardStyle;
  const iconListLength = props.iconList.filter(item => !!item.pic).length;
  const hasBigIcon = props.iconInfo.vipBigIcon ? 66 : 0;
  const maxWidthSize = 288 - hasBigIcon - iconListLength * 39 - 22;
  return {
    color: nickColor,
    maxWidth: `${maxWidthSize}px`,
  };
});

const integralUrl = decodeURIComponent('https://film.qq.com/weixin/v3/web-to-phone/index.html?pid=points');
// 直接展示钻石页面
const diamondsUrl = decodeURIComponent('https://film.video.qq.com/vip/uc/diamond-center-web/#/?isDarkMode=1');

const openIntegral = () => {
  if (!isEvo) {
    window.open(integralUrl);
    return;
  }
  if (isMac) {
    vnContext.external.openQQLive(`qqlive://insitebrowsewindow/?url=${integralUrl}`);
  } else {
    vnContext.external.openQQLive(`qqlive://openportal/portalurl=${integralUrl}`);
  }
};

const openDiamonds = () => {
  if (!isEvo) {
    window.open(diamondsUrl);
    return;
  }
  vnContext.external.openQQLive('qqlive://sso/diamonPurchase=1');
};

const personalPageUrl = 'https://v.qq.com/biu/u/history/?selectTab=history&subTabId=all';
const toPersonalPage = () => {
  if (!isEvo) {
    window.open(personalPageUrl);
    return;
  }
  vnContext.external.openQQLive('qqlive://openchannel/tab=usercenter');
};

const openVipMessage = () => {
  hasNewMsg.value = false;
  const url = 'https://v.qq.com/personal-center-header/pages/browser/index.html?header=msg&iframe_url=https%3A%2F%2Ffilm.video.qq.com%2Fweixin%2Fh5%2Fvip_messages%2Fmessage.html&ptag=txsppcwinxltc';
  if (!isEvo) {
    window.open(url);
    return;
  }
  vnContext.external.navigateURL(url);
};

const onMouseEnter = () => {
  isTipHover.value = true;
};

const onMouseLeave = () => {
  isTipHover.value = false;
};

onLoginReady(
  () => {
    if (isEvo) return;
    watch(
      () => loginStore.loginInfo.vuserid,
      // web端需要判断登录组件是否启用了FVIP切换相关功能，可以通过查询FVIP状态来判断。
      () => enableFVipSwitch.value = window.txv.login.isSubRoleLogin() || window.txv.login.isMainRoleLogin(),
      { immediate: true },
    );
  },
);

</script>

<style lang="scss" scoped>
.nav-card-login-info {
  display: flex;
  justify-content: space-between;
  overflow: visible;
}
.nav-info {
  display: flex;
  flex-direction: column;
  height: 56px;
  .nav-info-top {
    display: flex;
    align-items: center;
    height: 30px;
    margin-bottom: 4px;
    .user-nick {
      flex-shrink: 1;
      overflow: hidden;
      max-width: 110px;
      font-size: 20px;
      font-weight: 500;
      cursor: pointer;
    }
    .nav-type {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .user-icon-list {
      display: flex;
      align-items: center;
    }
    .user-icon {
      margin-right: 4px;
      height: 14px;
    }
  }
  .nav-info-bottom {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 18px;
    .integral,
    .diamonds {
      flex-shrink: 0;
      margin-right: 8px;
      cursor: pointer;
      font-size: 13px;
      font-weight: 400;
      opacity: 0.6;
      span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 70px;
    }
    }
    .message {
      width: 52px;
      margin-right: 16px;
      cursor: pointer;
      font-size: 13px;
      font-weight: 400;
      opacity: 0.6;
    }
    .integral:hover,
    .diamonds:hover,
    .message:hover {
      opacity: 1;
    }
    .message {
      position: relative;
    }
    .message-tip {
      position: absolute;
      top: 0px;
      right: 0px;
      width: 6px;
      height: 6px;
      background-color: #ff5959;
      border-radius: 50%;
    }
  }
}
.level {
  width: 56px;
  height: 56px;
  flex-shrink: 0;
}

.family-sub {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 400;
  opacity: 0.6;
}
.family-sub:hover {
  opacity: 1;
}

.tip-img-box {
  display: flex;
  align-items: center;
  position: relative;
  .tip-img {
    margin-left: 4px;
    width: 12px;
    height: 12px;
  }
  .tip-text-evo {
    position: fixed;
    top: 100px;
    left: 20px;
    width: 280px;
    height: 60px;
    border-radius: 8px;
    padding: 12px 13px 0 13px;
    background-color: #000;
    opacity: 1;
    .tip-text-title {
      border-radius: 8px;
      font-size: 12px;
      font-family: PingFang SC;
      color: #f2f2f2;
      font-weight: 400;
    }
  }
  .tip-text-web {
    position: absolute;
    top: 20px;
    left: 20px;
    transform: translateX(-50%);
    width: 280px;
    height: 60px;
    border-radius: 8px;
    padding: 12px 13px 0 13px;
    background-color:  #000;
    opacity: 1;
    .tip-text-title {
      border-radius: 8px;
      font-size: 12px;
      font-family: PingFang SC;
      color: #f2f2f2;
      font-weight: 400;
    }
  }
}

</style>
